import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Button, Form, Row, Col, Select, Input} from 'antd'
import {SearchOutlined, PlusOutlined} from '@ant-design/icons'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import UPM from '../../../constants/urlPermissionMappings'
import ApiManagementAPI from '../../../apis/apiManagementAPI'
import BoundModal from './BoundModal'
import {withTranslation} from 'react-i18next'

@inject('apiManagementStore', 'mappingManagementStore')
@observer
class SearchForm extends Component {
  state = {
    apiType: '',
    boundVisible: false,
    custList: [],
    businessTypeList: [],
  }
  formRef = React.createRef()

  componentDidMount() {
    const {apiManagementStore} = this.props
    apiManagementStore.onSearchApiAction({
      apiName: '',
      status: null,
      outboundType: '',
    }, 1, PAGE_SIZE_DEFAULT)
    this.getCust()
    this.getBusinessType()
    this.handleSearch()
    // mappingManagementStore.onGetOutboundTypeAction({
    //   createDateBegin: "",
    //   createDateEnd: "",
    //   outboundType: null,
    //   apiName: '',
    //   name: '',
    //   status: null,
    // })
    // mappingManagementStore.onGetInboundTypeAction({
    //   createDateBegin: "",
    //   createDateEnd: "",
    //   inboundType: null,
    //   apiName: '',
    //   name: '',
    //   status: null,
    // })
    apiManagementStore.onChangeDirectionType('OUTBOUND')
  }

  // onChange=(value)=>{
  //   const { apiManagementStore } = this.props
  //   this.setState({
  //     apiType: '',
  //   })
  //   this.formRef.current.setFieldsValue({
  //     customer: '',
  //     apiName: '',
  //     status: null
  //   })
  //   apiManagementStore.onChangeDirectionType(value)
  //   if(value==='OUTBOUND') {
  //     apiManagementStore.onSearchApiAction({
  //       apiName: '',
  //       status: null,
  //       outboundType: '',
  //     }, 1, PAGE_SIZE_DEFAULT)
  //   }else {
  //     apiManagementStore.onSearchInboundAction({
  //       name: '',
  //       status: null,
  //       inboundType: '',
  //     }, 1, PAGE_SIZE_DEFAULT)
  //   }
  // }
  getCust = () => {
    ApiManagementAPI.getCustAction().then(res => {
      this.setState({
        custList: res.data.data
      })
    })
  }
  getBusinessType = () => {
    ApiManagementAPI.getBusinessTypeAction().then(res => {
      this.setState({
        businessTypeList: res.data.data
      })
    })
  }
  onChangeInboundOutbound = (value) => {
    const {apiManagementStore, mappingManagementStore} = this.props
    const {directionType} = apiManagementStore
    if (value === undefined) {
      this.setState({
        apiType: ''
      })
    } else {
      this.setState({
        apiType: value,
      })
    }
    this.formRef.current.setFieldsValue({
      apiName: undefined
    })
    if (directionType === 'OUTBOUND') {
      mappingManagementStore.onGetOutboundNameAction({
        createDateBegin: '',
        createDateEnd: '',
        outboundType: value,
        apiName: '',
        name: '',
        status: null,
      })
    } else {
      mappingManagementStore.onGetInboundNameAction({
        createDateBegin: '',
        createDateEnd: '',
        inboundType: value,
        apiName: '',
        name: '',
        status: null,
      })
    }
  }
  handleResearch = (dir) => {
    this.handleSearch(dir)
  }
  handleSearch = (dir, pageNo) => {
    const {apiManagementStore} = this.props
    // const { directionType } = apiManagementStore
    if (dir) {
      this.formRef.current.setFieldsValue({
        direction: dir
      })
    }
    this.formRef.current.validateFields().then(fieldsValue => {
      // apiManagementStore.onSearchApiAction({
      //   name: fieldsValue.apiName,
      //   direction: fieldsValue.direction,
      //   customer: fieldsValue.customer,
      //   businessType: fieldsValue.businessType,
      //   apiName: fieldsValue.apiName,
      //   status: fieldsValue.status,
      // }, 1)
      apiManagementStore.onSearchApiAction({
        name: fieldsValue.apiName,
        direction: fieldsValue.direction,
        customer: fieldsValue.customer,
        businessType: fieldsValue.businessType,
        apiName: fieldsValue.apiName,
        status: fieldsValue.status,
        dataIngestion: fieldsValue.dataIngestion,
        dataType: fieldsValue.dataType
      }, pageNo ? pageNo : apiManagementStore.pageNo)

      // if(directionType==='OUTBOUND') {
      //
      // }else {
      //   apiManagementStore.onSearchInboundAction({
      //     name: fieldsValue.apiName,
      //     status: fieldsValue.status,
      //     inboundType: fieldsValue.customer,
      //   }, 1, PAGE_SIZE_DEFAULT)
      // }
    }).catch(err => { })
  }
  handleCreate = () => {
    this.setState({
      boundVisible: true
    })
  }
  handleCancel = () => {
    this.setState({
      boundVisible: false
    })
    this.handleSearch()
  }

  render() {
    const {apiManagementStore, location, t} = this.props
    const {directionType} = apiManagementStore
    // const {inboundTypeList, inboundNameList, outboundTypeList, outboundNameList} = mappingManagementStore
    return (
      <>
        <Form ref={this.formRef} initialValues={{direction: 'INBOUND'}} size="middle" className="searchForm" layout="vertical">
          <div className="searchFormTitle">
            <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
          </div>
          <Row gutter={[10, 0]}>
            <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
              <Form.Item name="direction" label={t(`apiManagement.direction`)}>
                <Select placeholder={t(`general.pleaseSelect`)}>
                  <Select.Option key="INBOUND" value="INBOUND">INBOUND</Select.Option>
                  <Select.Option key="OUTBOUND" value="OUTBOUND">OUTBOUND</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
              <Form.Item name="customer" label={t(`apiManagement.customer`)}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                  {this.state.custList.length > 0 ? this.state.custList.map(item => <Select.Option key={item.id}
                                                                                                   value={item.id}>{item.customer}</Select.Option>) : null}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
              <Form.Item name="businessType" label={t(`apiManagement.businessType`)}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                  {this.state.businessTypeList.length > 0 ? this.state.businessTypeList.map(item => <Select.Option key={item.businessType}
                                                                                                                   value={item.businessType}>{item.businessType}</Select.Option>) : null}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
              <Form.Item name="status" label={t(`apiManagement.status`)}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                  <Select.Option key="1" value="Normal">Normal</Select.Option>
                  <Select.Option key="2" value="Freeze">Freeze</Select.Option>
                  <Select.Option key="3" value="Abnormal">Abnormal</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
              <Form.Item name="apiName" label={t(`apiManagement.apiName`)}>
                <Input placeholder={t(`general.pleaseEnter`)} allowClear/>
                {/*            <Select placeholder="Please select ..." allowClear showSearch disabled={this.state.apiType === ''}>*/}
                {/*                {directionType==='INBOUND'?*/}
                {/*inboundNameList.map(item => <Select.Option key={item.name} value={item.name}>{item.name}</Select.Option>):*/}
                {/*outboundNameList.map(item => <Select.Option key={item.name} value={item.name}>{item.name}</Select.Option>)*/}
                {/*                }*/}
                {/*            </Select>*/}
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
              <Form.Item name="dataIngestion" label={t(`apiManagement.dataIngestion`)}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                  <Select.Option key="DATASOURCE" value="DATASOURCE">{t(`apiManagement.dataSource`)}</Select.Option>
                  <Select.Option key="DATATARGET" value="DATATARGET">{t(`apiManagement.dataTarget`)}</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
              <Form.Item name="dataType" label={t(`apiManagement.dataType`)}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                  <Select.Option key="HTTP" value="HTTP">HTTP</Select.Option>
                  <Select.Option key="DB" value="DB">DB</Select.Option>
                  <Select.Option key="SFTP" value="SFTP">SFTP</Select.Option>
                  <Select.Option key="Blob" value="Blob">Blob</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12} span={12} offset={8} style={{textAlign: 'right', marginTop: 30}}>
              <Button onClick={() => this.handleSearch(null, 1)} style={{marginLeft: 10}} type='danger'>{t(`general.search`)}</Button>
              <Button onClick={this.handleCreate} type="primary" icon={<PlusOutlined/>}>{t(`general.add`)}</Button>
            </Col>
          </Row>
        </Form>
        {this.state.boundVisible ? <BoundModal
          boundVisible={this.state.boundVisible}
          handleCancel={this.handleCancel}
          handleResearch={this.handleResearch}
          direction={directionType}
          title="add"
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchForm)
